import { render, staticRenderFns } from "./OpenFlexureHeader.vue?vue&type=template&id=209771a4&scoped=true&"
import script from "./OpenFlexureHeader.vue?vue&type=script&lang=js&"
export * from "./OpenFlexureHeader.vue?vue&type=script&lang=js&"
import style0 from "./OpenFlexureHeader.vue?vue&type=style&index=0&id=209771a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209771a4",
  null
  
)

export default component.exports